// This code has been fully generated by an AI.
const MARKDOWN_HEADING = /^#{1,6}\s+(.+?)\s*#*\s*$/;

export function stripReleaseVersionHeading(changelog: string, version: string): string {
  const lines = changelog.split(/\r?\n/);
  const firstContentLine = lines.findIndex(line => line.trim() !== '');
  if (firstContentLine === -1) return changelog;

  const match = lines[firstContentLine].trim().match(MARKDOWN_HEADING);
  if (!match) return changelog;

  const heading = match[1]
    .replace(/[`*_~]/g, '')
    .trim()
    .replace(/^release\s+/i, '')
    .replace(/^v/i, '');
  const normalizedVersion = version.replace(/^v/i, '');
  if (
    heading !== normalizedVersion &&
    !heading.startsWith(`${normalizedVersion} (`)
  ) return changelog;

  lines.splice(firstContentLine, 1);
  while (firstContentLine < lines.length && lines[firstContentLine].trim() === '') {
    lines.splice(firstContentLine, 1);
  }
  return lines.join('\n').trimStart();
}
